<!-- src/App.svelte -->
<script>
  import { isEnglish } from "./stores/cookies.js"; // readable store
  // import { setIsEnglish } from ...  ← only if needed here

  import Router from "svelte-spa-router";
  import { location } from "svelte-spa-router";

  import Home from "./pages/Home.svelte";
  import OurTeam from "./pages/OurTeam.svelte";
  import Services from "./pages/Services.svelte";
  import Contact from "./pages/Contact.svelte";
  import Redirect from "./pages/Redirect.svelte";

  const defaultTitle = "Vredenburg Dierehospitaal";

  // Title map – easy to extend later
  const titles = {
    "/": {
      en: "Home | Weskus Veeartseny",
      af: "Tuis | Weskus Veeartseny",
    },
    "/ourteam": {
      en: "Our Team | Weskus Veeartseny",
      af: "Ons Span | Weskus Veeartseny",
    },
    "/services": {
      en: "Services | Weskus Veeartseny",
      af: "Dienste | Weskus Veeartseny",
    },

    "/contact": {
      en: "Contact Us | Weskus Veeartseny",
      af: "Kontak Ons | Weskus Veeartseny",
    },
    // add more routes here
  };

  // Reacts to BOTH route changes AND language changes
  $: {
    const page = $location || "/";
    const lang = $isEnglish ? "en" : "af";

    const title = titles[page]?.[lang] || defaultTitle;

    document.title = title;
  }

  const routes = {
    "/": Home,
    "/ourteam": OurTeam,
    "/services": Services,
    "/contact": Contact,
    "*": Redirect,
  };
</script>

<main class="min-h-screen bg-gray-50">
  <Router {routes} />
</main>
